import { API_URL, THEME_COLOR, zerofill } from "../constant";
import React, { useEffect, useState } from "react";
import HeaderBack from "../layout/HeaderBack";
import { useLocalStorage } from "../useLocalStorage";
import { Backdrop, CircularProgress, Stack, TextField } from "@mui/material";
import { LocalizationProvider, MobileDatePicker } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import toast, { Toaster } from "react-hot-toast";
import jwt  from 'jsonwebtoken';
// import { Link } from "react-router-dom";

const EditProfile = () => {
  const [token, setToken] = useLocalStorage("token", "");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [icNo, setICNo] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isOpenBackdrop, setIsOpenBackdrop] = useState(false);

  async function UpdateProfile() {
    var myHeaders = new Headers();
    myHeaders.append("x-access-token", token);
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    var urlencoded = new URLSearchParams();
    urlencoded.append("firstname", document.getElementById("FirstName").value);
    urlencoded.append("lastname", document.getElementById("LastName").value);
    urlencoded.append("email", document.getElementById("Email").value);
    urlencoded.append("phone", document.getElementById("Phone").value);
    urlencoded.append("whatsapp", document.getElementById("Whatsapp").value);
    urlencoded.append("birthdate",  `${birthDate.getFullYear()}-${zerofill(birthDate.getMonth() + 1)}-${birthDate.getDate()}`);
    urlencoded.append("icno", icNo);

    var requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    return fetch(`${API_URL}api/profile`, requestOptions)
      .then((response) => response.text())
      .catch((error) => console.log("error", error));
  }

  async function CheckUsername() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    var urlencoded = new URLSearchParams();
    urlencoded.append("username", username);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    return fetch(`${API_URL}api/register/checkusername`, requestOptions)
      .then((response) => response.text())
      .catch((error) => console.log("error", error));
  }

  async function CheckEmail() {
    var myHeaders = new Headers();
    myHeaders.append("x-access-token", token);
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    var urlencoded = new URLSearchParams();
    urlencoded.append("email", email);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    return fetch(`${API_URL}api/register/checkemail`, requestOptions)
      .then((response) => response.text())
      .catch((error) => console.log("error", error));
  }
  async function CheckPhone() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    var urlencoded = new URLSearchParams();
    urlencoded.append("phone", phone);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    return fetch(`${API_URL}api/register/checkphone`, requestOptions)
      .then((response) => response.text())
      .catch((error) => console.log("error", error));
  }

  async function FormValidation() {
    let valid = true;

    let fields = ["FirstName", "Email", "Phone", "Whatsapp", "ICNo"];
    let numberfields = [ "Phone", "Whatsapp", "ICNo"];
    let phonefields = [ "Phone", "Whatsapp"];

    fields.map((value) => {
      let field = document.getElementById(value);
      if (!field || field.value == "") {
        document
          .getElementById(value + "Validation")
          .setAttribute("data-error", "This field is required");
        field.classList.remove("valid");
        field.classList.add("invalid");
      } else {
        field.classList.remove("invalid");
        field.classList.add("valid");
      }
    });
    for(let value of numberfields){
        let field = document.getElementById(value);
        if (!field || field.value == "" || field.value.match(/[^0-9]/g)) {
          document
            .getElementById(value + "Validation")
            .setAttribute("data-error", "Invalid format");
          field.classList.remove("valid");
          field.classList.add("invalid");
        } else {
          field.classList.remove("invalid");
          field.classList.add("valid");
        }
    }
    for(let value of phonefields){
        let field = document.getElementById(value);
        if (!field || field.value == "" || !field.value.match(/(?:08[0-9]{8,12})/g)) {
          document
            .getElementById(value + "Validation")
            .setAttribute("data-error", "Invalid format");
          field.classList.remove("valid");
          field.classList.add("invalid");
        } else {
          field.classList.remove("invalid");
          field.classList.add("valid");
        }
    }

    // if (document.getElementById("Email").value != "") {
    //   let response = await CheckEmail();
    //   response = JSON.parse(response);
    //   if (response.status == 200) {
    //     document
    //       .getElementById("EmailValidation")
    //       .setAttribute("data-error", response.message);
    //     document.getElementById("Email").classList.remove("valid");
    //     document.getElementById("Email").classList.remove("invalid");
    //     document.getElementById("Email").classList.add(response.class);
    //   } else {
    //   }
    // }

    // if (document.getElementById("Phone").value != "") {
    //   let response = await CheckPhone();
    //   response = JSON.parse(response);
    //   if (response.status == 200) {
    //     document
    //       .getElementById("PhoneValidation")
    //       .setAttribute("data-error", response.message);
    //     document.getElementById("Phone").classList.remove("valid");
    //     document.getElementById("Phone").classList.remove("invalid");
    //     document.getElementById("Phone").classList.add(response.class);
    //   } else {
    //   }
    // }

    let countvalid = document.getElementsByClassName("invalid").length;
    valid = countvalid === 0;

    return valid;
  }

  function getNewToken(){
      var myHeaders = new Headers();
      myHeaders.append("x-access-token", token);

      var requestOptions = {
          method: 'GET',
          headers: myHeaders,
          redirect: 'follow'
      };

      return fetch(`${API_URL}api/token`, requestOptions)
      .then(response => response.json())
      .catch(error => console.log('error', error))
  }

  async function SubmitHandler(event) {
    event.preventDefault();
    setIsOpenBackdrop(true);
    let valid = await FormValidation();
    if (valid) {
      let response = await UpdateProfile();

      response = JSON.parse(response);
      if (response.status == 200) {
        let restoken = await getNewToken();
        if(restoken.status == 200){
            setToken(restoken.token)
            window.history.replaceState(null, null, `/`);
            toast.success("sukses");
            window.location.reload();
        }else{
            toast.error(response.message)
        }
      } else {
      }
    }
    setIsOpenBackdrop(false);
  }

  function getData() {
    var myHeaders = new Headers();
    myHeaders.append("x-access-token", token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(`${API_URL}api/member`, requestOptions)
      .then((response) => response.json())
      .catch((error) => {});
  }

  async function InitialData() {
    let response = await getData();
    if (response.status == 200) {
        let jwttoken = jwt.decode(token);
        setUsername(jwttoken.UserName)
        setFirstName(response.data.FirstName)
        setLastName(response.data.LastName)
        setEmail(response.data.Email)
        setPhone(response.data.MobilePhone)
        setWhatsapp(response.data.Whatsapp)
        setBirthDate(new Date(response.data.BirthDate))
        setICNo(response.data.ICNo)
    }else{
        toast.error(response.message)
    }
  }

  useEffect(() => {
    InitialData();
  }, []);

  return (
    <React.StrictMode>
      <Toaster position="bottom-center" />
      <HeaderBack title="Profile" />
      <div
        className="row"
        style={{ padding: "10px", backgroundColor: "white" }}
      >
        <form className="col s12">
          <div className="row">
            <div className="input-field col s6">
              <input
                placeholder="First Name"
                id="FirstName"
                type="text"
                className="input-upper validate"
                required
                onChange={(e) => setFirstName(e.target.value)}
                value={firstName}
              />
              <label className="active" htmlFor="FirstName" data-error="wrong">
                First Name
              </label>
              <span
                className="helper-text"
                id="FirstNameValidation"
                data-error="this field is required"
                data-success=""
              ></span>
            </div>
            <div className="input-field col s6">
              <input
                placeholder="Last Name"
                id="LastName"
                type="text"
                className="input-upper validate"
                onChange={(e) => setLastName(e.target.value)}
                value={lastName}
              />
              <label className="active" htmlFor="LastName">
                Last Name
              </label>
              <span
                className="helper-text"
                id="LastNameValidation"
                data-error="this field is required"
                data-success=""
              ></span>
            </div>
          </div>
          <div className="row">
            <div className="input-field col s12">
              <input
                value={username}
                disabled
                placeholder="Username"
                id="Username"
                type="text"
                className="validate"
                onChange={(e) => setUsername(e.target.value)}
              />
              <label className="active" htmlFor="Username">
                Username
              </label>
              <span
                className="helper-text"
                id="UsernameValidation"
                data-error="insert an unique username"
                data-success=""
              ></span>
            </div>
          </div>
          <div className="row">
            <div className="input-field col s12">
              <Stack>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <MobileDatePicker
                    label="Birth Date"
                    value={birthDate}
                    onChange={async (newValue) => {
                      setBirthDate(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField {...params} helperText={null} />
                    )}
                  />
                </LocalizationProvider>
              </Stack>
            </div>
          </div>
          <div className="row">
            <div className="input-field col s12">
              <input
                placeholder="Email"
                id="Email"
                type="email"
                className="validate"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
              />
              <label className="active" htmlFor="Email">
                Email
              </label>
              <span
                className="helper-text"
                id="EmailValidation"
                data-error="incorrect email format"
                data-success=""
              ></span>
            </div>
          </div>
          <div className="row">
            <div className="input-field col s12">
              <input
                id="Phone"
                type="tel"
                placeholder="08XXXXX"
                pattern="08[0-9]{8,}"
                className="validate"
                onChange={(e) => setPhone(e.target.value)}
                value={phone}
                required
              />
              <label className="active" htmlFor="Phone">
                Phone Number
              </label>
              <span
                className="helper-text"
                id="PhoneValidation"
                data-error="incorect format"
                data-success=""
              ></span>
            </div>
          </div>
          <div className="row">
            <div className="input-field col s12">
              <input
                id="Whatsapp"
                type="tel"
                placeholder="08XXXXX"
                pattern="08[0-9]{8,}"
                className="validate"
                onChange={(e) => setWhatsapp(e.target.value)}
                value={whatsapp}
                required
              />
              <label className="active" htmlFor="Whatsapp">
                Whatsapp
              </label>
              <span
                className="helper-text"
                id="WhatsappValidation"
                data-error="incorect format"
                data-success=""
              ></span>
            </div>
          </div>
          <div className="row">
            <div className="input-field col s12">
              <input
                placeholder="ICNo"
                id="ICNo"
                type="tel"
                pattern="[0-9]{10,}"
                className="validate"
                value={icNo}
                onChange={(e) => setICNo(e.target.value)}
              />
              <label className="active" htmlFor="IC No">
                ICNo
              </label>
              <span
                className="helper-text"
                id="ICNoValidation"
                data-error="incorrect IC No format"
                data-success=""
              ></span>
            </div>
          </div>

          <div className="row">
            <div className="col s6"></div>
            <div className="col s6 center">
              <a
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                className={`btn ${THEME_COLOR}`}
                onClick={SubmitHandler}
              >
                <i></i>Update
              </a>
            </div>
          </div>
        </form>
      </div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isOpenBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </React.StrictMode>
  );
};

export default EditProfile;
